module.exports = __webpack_public_path__ + "fonts/NoirPro-Light.bbd56c69.woff";